import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Denver needed",
      "Ideal for CYS international flyers connecting through DIA",
      "Perfect for F.E. Warren AFB families on PCS orders",
      "Great for Wyoming state government employees on official travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Laramie County post offices",
      "Good for planned international trips from CYS",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection and restart the clock",
      "In-person clerk appointment required at Laramie County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Denver — ~100 miles, ~2 hour drive via I-25",
      "NPIC appointment required before driving to Denver",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Wyoming has zero passport agencies — Denver is the only option",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Cheyenne"
      headingExtra="WY"
      introText="Cheyenne and Wyoming travelers — CYS international flyers connecting through Denver International Airport, F.E. Warren Air Force Base military families on PCS orders, Wyoming state government employees on official overseas travel, Cheyenne Frontier Days international performers and rodeo competitors, and Laramie County Community College study-abroad students — have several options for getting a passport fast. Here is how they compare, and why most Wyoming residents choose a U.S. Department of State registered passport courier rather than making a last-minute drive to the Denver Passport Agency."
      options={options}
      emergencyDescription="Wyoming has zero regional passport agencies. The closest agency is in Denver, Colorado — roughly 100 miles south via I-25, about 2 hours each way depending on Front Range traffic. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted at the Denver Passport Agency."
      disclaimerText="*Processing speed depends on eligibility and documentation. Wyoming has no regional passport agency — the closest is Denver, Colorado, roughly 100 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}